import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { LocalFaturamentoMultiselectComponent } from './local-faturamento-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        LocalFaturamentoMultiselectComponent
    ],
    exports: [
        LocalFaturamentoMultiselectComponent
    ]
})
export class LocalFaturamentoMultiselectModule { }
